import { render, staticRenderFns } from "./StudentReceiptDetail.vue?vue&type=template&id=52451e14&scoped=true"
import script from "./StudentReceiptDetail.vue?vue&type=script&lang=js"
export * from "./StudentReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentReceiptDetail.vue?vue&type=style&index=0&id=52451e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52451e14",
  null
  
)

export default component.exports